import type { KeyboardEventHandler } from 'react';
import { useCallback, useState } from 'react';

export const useSearchSuggestionsKeyboardNavigation = (totalLength: number) => {
  const [activeElement, setActiveElement] = useState<number | null>(null);

  const onKeyDown = useCallback<KeyboardEventHandler<HTMLDivElement>>(
    (event) => {
      const { key } = event;

      if (key !== 'ArrowDown' && key !== 'ArrowUp') {
        return;
      }

      event.preventDefault();

      if (key === 'ArrowDown') {
        setActiveElement((prev) => {
          if (prev === null || prev + 1 === totalLength) {
            return 0;
          }

          return prev + 1;
        });
      }

      if (key === 'ArrowUp') {
        setActiveElement((prev) => {
          if (prev === null || prev === 0) {
            return totalLength - 1;
          }

          return prev - 1;
        });
      }
    },
    [totalLength],
  );

  const resetActiveElement = useCallback(() => {
    setActiveElement(null);
  }, []);

  return { activeElement, onKeyDown, resetActiveElement };
};
